<div [style.color]="this.iconColor">

  <!-- Diminuir fonte -->
  <span class="item-access font-control" [class.disabled]="isMinFont()" pTooltip="Diminuir fonte" tooltipPosition="left"
    (click)="decreaseFont()">
    A-
  </span>

  <!-- Aumentar fonte -->
  <span class="item-access font-control" [class.disabled]="isMaxFont()" pTooltip="Aumentar fonte" tooltipPosition="left"
    (click)="increaseFont()">
    A+
  </span>

  <!-- Toggle uppercase / capitalize -->
  <span class="item-access font-toggle" pTooltip="Alternar maiúsculas / capitalizado" tooltipPosition="left"
    (click)="toggleUpperCaseIcon()">
    {{ selectedUpper ? 'AA' : 'Aa' }}
  </span>


  <!-- Contraste -->
  <span class="item-access contrast" pTooltip="Inverter Cores" tooltipPosition="left"
    [ngClass]="{'selected': selectedConstrast}" (click)="toggleConstrastIcon()">
    <i class="pi pi-circle"></i>
  </span>

</div>